import CommentAddIcon from '@atlaskit/icon/core/comment-add';
import * as React from 'react';

export function SvgCommentAdd() {
  return <CommentAddIcon label="" testId="ads-refreshed-icon" />;
}
